/*
 *选择企业
*/
import React from 'react'
import './login.less'
import api from '../../api/api.js'
import logo from './../../imgs/logo.png'
import { Form, Input, Button,Select,Icon, message, Carousel } from 'antd'
import {API_CONFIG} from '../../api/config.js'

class SelectGroup extends React.Component {
    state = {
        enterprise_list: [],
        eachList: [],
        cuttent: 0,
        grounpLoading: false
    }
    clickPrev = () => {
        const { cuttent } = this.state
        const enterprise_list = JSON.parse(sessionStorage.getItem('team'))
        if(cuttent < 1) return
        this.setState({
            cuttent:cuttent - 1
        },() =>{
            if(enterprise_list.length <= 3) return;
            this.slider.style.transform = `translate(-${86 * this.state.cuttent}px, 0px)`
        })  
    }
    
    clickNext = () => {
        const { cuttent,  } = this.state
        const enterprise_list = JSON.parse(sessionStorage.getItem('team'))
        if(cuttent + 1 >=  enterprise_list.length) return;
        this.setState({
            cuttent:cuttent + 1,
        }, () => {
            if(enterprise_list.length <= 3) return;
            this.slider.style.transform = `translate(-${86 * this.state.cuttent}px, 0px)`
            this.slider.style.transition = 'transform 0 ease 0'
        })
    }

    OnSelectGrounp = () => {
        const { cuttent } = this.state;
        const enterprise_list = JSON.parse(sessionStorage.getItem('team'))
        let companychange = sessionStorage.getItem('companychange')
        this.setState({grounpLoading: true})
        if(companychange === 'true'){
            // 获取企业token
            api.queryCompanyToken({
                access_token: sessionStorage.getItem('changeCompany_token'),
                corp_uuid: enterprise_list[cuttent].id,
            }).then(res=>{
                if(res.code === 0 && res.content) {
                    sessionStorage.setItem('company_token',res.content.access_token)
                    document.cookie= `${API_CONFIG.cloud_token}=${res.content.access_token};domain=colourlife.com;;path=/;`
                    if(sessionStorage.getItem('market_url')){
                        let market_url = sessionStorage.getItem('market_url')
                        window.location.href=`${market_url}`
                    } else {
                        window.location.href=`${API_CONFIG.yun_base}`
                    }
                }
            })
        } else {
            //登录指定团队后台
            api.get_company_login({
                access_token: sessionStorage.getItem('access_token'),
                corp_uuid: enterprise_list[cuttent].id,
                source:sessionStorage.getItem('source')
            }).then(res=>{
                this.setState({grounpLoading: false})
                if(res.code===0) {
                    sessionStorage.setItem('company_token',res.content.access_token)
                    document.cookie= `${API_CONFIG.cloud_token}=${res.content.access_token};domain=colourlife.com;;path=/;`
                    if(sessionStorage.getItem('market_url')){
                        let market_url = sessionStorage.getItem('market_url')
                        window.location.href=`${market_url}`
                    } else {
                        window.location.href=`${API_CONFIG.yun_base}`
                    }
                }
            })
        }
    }
    render() {
        const enterprise_list = JSON.parse(sessionStorage.getItem('team'))
        const { cuttent, grounpLoading } = this.state
        return (
            <div className='enterprise_login'>
                <h3 className='title'> 请选择要登录企业</h3>
                <Icon type="left-circle" className='left-circle' onClick={this.clickPrev}/>
                <Icon type="right-circle"  className='right-circle' onClick={this.clickNext } />
                <div className="container" ref="container" >
                    <ul ref="sliderContent" className='slider-content' ref={el => (this.slider = el)}>    
                        {enterprise_list !== null && enterprise_list.map((item,i) => (
                            <li key={i} >
                                <img
                                    className={`${this.state.cuttent === i ? 'current' : ''}`}
                                    onClick={() => {
                                        this.setState({ cuttent: i })
                                    }} 
                                    src={item.icon||logo} alt={i} 
                                />
                            </li>
                        ))
                        }
                    </ul>
                </div>
                <p className='select-name'>
                    <Icon type="check-circle" className='check-circle' />
                    {enterprise_list[cuttent].name}
                </p>
                <Button 
                    type='primary' 
                    className='register-btn' 
                    onClick={this.OnSelectGrounp} 
                    loading={grounpLoading}
                >登录</Button>
            </div>
        )
    }
}
export default Form.create({})(SelectGroup);


// WEBPACK FOOTER //
// ./src/pages/login/SelectGroup.jsx